<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer" @changeIsOperationPossible="changeIsOperationPossible">
      <b-overlay :show="overlayShow" rounded="sm">
        <div class="base-color overflow-auto mh-550 shadow">
          <form method="post" action="#" class="form-horizontal">
            <div class="col-sm-12 p-5 mt-3">
              <span class="text-break" v-if="mailAddressInMsg && !brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{mailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
              <span class="text-break" v-else-if="!mailAddressInMsg && brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="brideMailAddressInMsg">{{brideMailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
              <span class="text-break" v-else-if="mailAddressInMsg && brideMailAddressInMsg" >ご入力いただいたメールアドレス（<span id="mailAddressInMsg">{{mailAddressInMsg}}</span>, <span id="brideMailAddressInMsg">{{brideMailAddressInMsg}}</span>）にメールを
              送信いたしました。メールが届いているかご確認をお願いいたします。
              メールアドレスを変更する場合は以下のボタンからメールアドレスの変更をお願いいたします。</span>
            </div>
            <div class="col-sm-12">
              <div class="w-75 mt-5-auto">
                <b-button block variant="outline-secondary" class="sub-button-color white-btn-disabled" @click="showMailForm" :disabled="!isOperationPossible">メールアドレスを変更する場合</b-button>
              </div>
            </div>
            <transition>
              <div class="mail-send-form col-sm-12" v-show="isShowMailForm">
                <label for="mailAddress" class="control-label col-sm-12 mb-0">メールアドレス(1){{shinroShinpu1 !== 'shinro' ? '(ご新婦様)' : '(ご新郎様)'}}</label>
                <div class="input-group">
                  <input type="text" id="mailAddress" class="form-control input-sm" :class="{'is-invalid is-invalid-custom' : validation.hasError('mailAddress')}" v-model="mailAddress" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback">{{ validation.firstError('mailAddress') }}</div>
                </div>
                <label for="brideMailAddress" class="control-label col-sm-12 mb-0 mt-2">メールアドレス(2){{shinroShinpu2 !== 'shinpu' ? '(ご新郎様)' : '(ご新婦様)'}}</label>
                <div class="input-group">
                  <input type="text" id="brideMailAddress" class="form-control input-sm send-mail-input" :class="{'is-invalid is-invalid-custom' : validation.hasError('brideMailAddress')}" v-model="brideMailAddress" @blur="sendSignalingInputData" :disabled="!isOperationPossible"/>
                  <div class="invalid-feedback">{{ validation.firstError('brideMailAddress') }}</div>
                </div>
                <div class="input-group-btn text-right">
                  <b-button variant="outline-secondary" class="sub-button-color pl-4 pr-4 white-btn-disabled mt-3" @click="sendMail" :disabled="!isOperationPossible">送信</b-button>
                </div>
              </div>
            </transition>
          </form>
        </div>
      </b-overlay>
    </CustomerMeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<style scoped type="text/css">
.v-enter-active, .v-leave-active {
  transition: opacity .3s
}
.v-enter, .v-leave-to {
  opacity: 0
}
</style>
<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import SimpleVueValidation from 'simple-vue-validator'
import CustomerUpdateModel from '@/models/CustomerUpdateModel'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'CustomerMeetingSendMail',
  components: { CommonLayout, CommonModal, CustomerMeetingLayout },
  data () {
    return {
      isShowMailForm: false,
      overlayShow: false,
      mailAddressInMsg: '',
      brideMailAddressInMsg: '',
      mailAddress: '',
      brideMailAddress: '',
      isSendFirstSignalingData: false,
      isOperationPossible: false,
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag,
      shinroShinpu1: '',
      shinroShinpu2: ''
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.sendSignalingInputData()
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })
        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (!cstore.getters.isOperationPossible) {
          if (newData['event'] === 'click' && newData['id'] === 'sendMail') {
            this.signalSendMail()
          }

          if (newData['event'] === 'click') {
            if (newData['id'] === 'next' || newData['id'] === 'back') {
              this.$router.push(newData['target_path'])
            }
          }
          if (newData['event'] === 'input' && !this.isOperationPossible) {
            for (let i = 0; i < newData['data'].length; i++) {
              if (newData['data'][i] && newData['data'][i].id) {
                let elm = document.getElementById(newData['data'][i].id)
                if (newData['data'][i].id === 'isShowMailForm') {
                  this.isShowMailForm = newData['data'][i].value
                } else if (newData['data'][i].target) {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                  // florist側で変更した値に対してvalidationを実行するためにchangeイベントを発火する
                  elm.dispatchEvent(new Event('change'))
                } else {
                  elm.value = newData['data'][i].value
                  elm.dispatchEvent(new Event('input'))
                  elm.dispatchEvent(new Event('change'))
                }
              }
            }
          }
        }
        if (newData['event'] === 'click') {
          if (sessionStorage.customerType !== this.consts.customerType.guest) {
            if (newData['id'] === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
              this.isOperationPossible = false
            } else if (newData['id'] === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
              this.isOperationPossible = true
            }
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  validators: {
    mailAddress: function (value) {
      if (this.brideMailAddress.trim()) {
        return Validator
          .value(value)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      } else {
        return Validator
          .value(value)
          .required(this.consts.validationMsg.meetingInput.mailAddress.required)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      }
    },
    brideMailAddress: function (value) {
      if (this.mailAddress.trim()) {
        return Validator
          .value(value)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      } else {
        return Validator
          .value(value)
          .required(this.consts.validationMsg.meetingInput.mailAddress.required)
          .email(this.consts.validationMsg.meetingInput.mailAddress.email)
          .regex(/^[\x20-\x7e]*$/, this.consts.validationMsg.meetingInput.mailAddress.halfWidth)
      }
    }
  },
  methods: {
    showMailForm () {
      try {
        this.isShowMailForm = !this.isShowMailForm
        this.sendSignalingInputData()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingInputData: function (e) {
      try {
        console.log('=== sendSignalingInputData 開始 ===')
        if (typeof e !== 'undefined' && e.type === 'blur') {
          console.log("if (typeof e !== 'undefined' && e.type === 'blur')")
          this.$validate(e.target.id)
        }
        const inputs = document.querySelectorAll('input')
        console.log('inputs ↓')
        console.log(inputs)
        let sendData = []
        for (var i = 0; i < inputs.length; i++) {
          if (typeof e !== 'undefined' && inputs[i].id === e.target.id) {
            sendData[i] = {'target': e.target.id, 'id': inputs[i].id, 'value': inputs[i].value}
          } else {
            sendData[i] = {'id': inputs[i].id, 'value': inputs[i].value}
          }
        }
        sendData.push({'id': 'isShowMailForm', 'value': this.isShowMailForm})
        SignalingModel.sendInputEvent(this, sendData)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendMail: async function () {
      try {
        if (this.isOperationPossible) {
          let isError = await this.$validate()
            .then((success) => {
              return !success
            })

          SignalingModel.sendClickEvent('sendMail', this)

          if (isError) {
            return false
          }
          // 空白文字のみの入力の可能性がある為、メールアドレスの空白文字を削除する
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.overlayShow = true
          const params = {
            'mailAddress': this.mailAddress,
            'brideMailAddress': this.brideMailAddress
          }
          await CustomerUpdateModel.apiSetStore(this.$bvModal, params, () => {
            this.overlayShow = false
          })
          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return false
      }
    },
    signalSendMail: async function () {
      try {
        if (!this.isOperationPossible) {
          let isError = await this.$validate()
            .then((success) => {
              return !success
            })

          if (isError) {
            return false
          }
          // 空白文字のみの入力の可能性がある為、メールアドレスの空白文字を削除する
          this.mailAddress = this.mailAddress.trim()
          this.brideMailAddress = this.brideMailAddress.trim()

          this.mailAddressInMsg = this.mailAddress
          this.brideMailAddressInMsg = this.brideMailAddress
          this.$refs.commonModal.msgBoxOk('メールを送信しました')
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changeIsOperationPossible (value) {
      this.isOperationPossible = value
    }
  },
  mounted () {
    try {
      this.isOperationPossible = false
      cstore.commit('setIsOperationPossible', this.isOperationPossible)
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  created: function () {
    try {
      this.shinroShinpu1 = cstore.getters.shinroShinpu1
      this.shinroShinpu2 = cstore.getters.shinroShinpu2
      if (cstore.getters.mailAddress) {
        this.mailAddressInMsg = cstore.getters.mailAddress.trim()
        this.mailAddress = cstore.getters.mailAddress.trim()
      }
      if (cstore.getters.brideMailAddress) {
        this.brideMailAddressInMsg = cstore.getters.brideMailAddress.trim()
        this.brideMailAddress = cstore.getters.brideMailAddress.trim()
      }
      if (cstore.getters.shinroShinpu1 === 'shinpu' && cstore.getters.shinroShinpu2 === 'shinro') {
        [this.mailAddressInMsg, this.brideMailAddressInMsg, this.mailAddress, this.brideMailAddress] = [this.brideMailAddressInMsg, this.mailAddressInMsg, this.brideMailAddress, this.mailAddress]
        this.shinroShinpu1 = 'shinro'
        this.shinroShinpu2 = 'shinpu'
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  destroyed () {
    try {
      if (CustomerUpdateModel.getStore()) {
        CustomerUpdateModel.removeStore()
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style scoped type="text/css">
  .white-btn-disabled:disabled {
    color: rgb(0, 123, 255);
    border-color: rgb(0, 123, 255);
    background-color: #fff;
    opacity: 1;
  }
  .form-control:disabled {
    background-color: #fff;
  }
  input[type=radio] {
    transform: scale(2);
  }
</style>



// WEBPACK FOOTER //
// src/pages/CustomerMeetingSendMail.vue